import Input from "../../../components/Input/Input";
import Select from "../../../components/Select/Select";
import Checkbox from "../../../components/CheckBox/Checkbox";
import DatePicker from "../../../components/DatePicker/DatePicker";

const Controls = {
  Input,
  Select,
  Checkbox,
  DatePicker,
};

export default Controls;
